// social-callback.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-social-callback',
  templateUrl: './social-callback.component.html',
  styleUrls: ['./social-callback.component.scss'],
})
export class SocialCallbackComponent implements OnInit {
  progress = 10;
  errorMsg = '';
  integrationDone = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private authService: AuthService // Ajuste para seu service real
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      const code = params['code'];
      const state = params['state'];
      const error = params['error'];
      if (error) {
        this.errorMsg = 'Autorização negada';
        this.progress = 100;
        return;
      }

      this.progress = 30;

      if (code && state) {
        this.finishSocialLogin(code, state);
      } else {
        this.errorMsg = 'Dados de autorização ausentes';
        this.progress = 100;
      }
    });
  }

  finishSocialLogin(code: string, state: string) {
    this.progress = 55;
    this.authService.socialOauthCallback(code, state).pipe(
      catchError((err) => {
        this.errorMsg = 'Falha ao integrar a conta';
        this.progress = 100;
        return EMPTY;
      })
    ).subscribe(resp => {
      // Aqui você pode armazenar dados do usuário, tokens, etc.
      this.progress = 100;
      this.integrationDone = true;
      // Se quiser fechar popup ou redirecionar, faça aqui
      // Exemplo: this.router.navigate(['/dashboard']);
    });
  }

  onCancel() {
    // Pode redirecionar para tela inicial, dashboard, etc.
    this.router.navigate(['/']);
  }
}
